import * as React from 'react';

export const NotFoundPage: React.StatelessComponent<{}> = () => {
  return (
    <main className="contentpage">
        <div className="container">
            <div className="row">
                <div className="col-md-12 col-sm-12">
                        <span className="big-text">404</span>
                        <p className="help-text">Sivua ei löytynyt</p>
                </div>
            </div>
        </div>
    </main>
  );
}


// WEBPACK FOOTER //
// ./src/components/notFound.tsx